import * as Yup from 'yup';
import checkoutFormModel from './checkoutFormModel';
import { i18n } from '../../../translate/i18n';
const {
  formField: {
    firstName,
    address1,
    city,
    zipcode,
    country,
  }
} = checkoutFormModel;


const getValidationSchema = () => [
  Yup.object().shape({
    [firstName.name]: Yup.string().required(i18n.t(firstName.requiredErrorMsg)),
    [zipcode.name]: Yup.string().required(i18n.t(zipcode.requiredErrorMsg)),
  }),
];

export default getValidationSchema;
